/**
 * @link https://mui.com/material-ui/react-alert/
 */

import * as React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeAlert() {
  const [open, setOpen] = React.useState(true);

  return (
    <Stack sx={{ width: '100%', pb: 5 }} spacing={2}>
      <Alert severity="error">This is an error alert — check it out!</Alert>
      <Alert severity="warning">This is a warning alert — check it out!</Alert>
      <Alert severity="success">This is a success alert — check it out!</Alert>
      <Alert severity="info">
        <AlertTitle>This is an info alert</AlertTitle>
        <Typography variant="body">With some additional information — <i>if you like</i></Typography>
      </Alert>
      <Collapse in={open}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          Close me!
        </Alert>
      </Collapse>
      <Button
        disabled={open}
        variant="outlined"
        sx={{maxWidth:'176px'}}
        onClick={() => {
          setOpen(true);
        }}
      >
        Re-open
      </Button>
      
      <ShowCode 
        codeString={`<>
  <Stack sx={{ width: '100%' }} spacing={2}>
    {/* Basic alerts with different severity levels */}
    <Alert severity="error">This is an error alert — check it out!</Alert>
    <Alert severity="warning">This is a warning alert — check it out!</Alert>
    <Alert severity="success">This is a success alert — check it out!</Alert>
    
    {/* Alert with title and additional content */}
    <Alert severity="info">
      <AlertTitle>This is an info alert</AlertTitle>
      <Typography variant="body2">With some additional information</Typography>
    </Alert>
    
    {/* Dismissible alert with close button */}
    <Alert
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => console.log('Close clicked')}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      This alert can be dismissed!
    </Alert>
  </Stack>
</>`} 
        scope={{ 
          React, 
          Alert, 
          AlertTitle, 
          Typography, 
          IconButton, 
          CloseIcon, 
          Stack 
        }} 
      />
    </Stack>
  );
}